export default __webpack_public_path__ + "static/media/crash.6233eaa9.mp3";